<template>
  <div class="orders-summary__status">
    <div
      class="orders-summary__status__icon"
      :class="'icon-white-' + type"
    >
      •
    </div>
    <div class="orders-summary__status__description">
      <span :id="name">{{ value }}</span>
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrdersSummaryStatus',
  props: [
    'value',
    'name',
    'type'
  ]
}
</script>
<style lang="scss">
  @import '../../../static/stylesheets/variables';

  .orders-summary__status {
    display: flex;
    align-items: center;
    margin-left: 20px;

    &__icon {
      font-size: 35px;
      margin-right: 7px;
    }

    .icon-white-error {
      color: #b40607;
    }
    .icon-white-correct {
      color: #47ba8d;
    }
    .icon-white-fixed {
      color: #f5a623;
    }

    &__label {
      font-size: 16px;
      font-weight: 800;
      line-height: 0.93;
      text-align: left;
      color: $label-color;
      width: auto;
      white-space: nowrap;
      margin-right: 5px;
      margin-left: 17px;
      letter-spacing: 1px;
     }

    &__description {
      font-size: 16px;
      font-weight: 400;
      line-height: 0.93;
      text-align: left;
      color: $label-color;
      width: auto;
      white-space: nowrap;
      letter-spacing: 1px;
    }
  }
</style>
